import type { ReactNode } from 'react'

function processText(text: string) {
	const result: ReactNode[] = []
	const lines = text.split('\n')
	lines.forEach((line, index) => {
		const isLast = index === lines.length - 1

		result.push(insertLinks(line))
		!isLast && result.push(<br key={`${line}-${index}`} />)
	})

	return result
}

const insertLinks = (text: string) => {
	const regex = /((https?|ftp):\/\/[^\s/$.?#].[^\s]*)/gi
	const elements = text
		.split(regex)
		.filter(element => element !== 'https' && element !== 'http')

	return elements.map((element, index) => {
		if (regex.test(element)) {
			return (
				<a
					className='mailbox-link'
					href={element}
					key={index}
					rel='noreferrer'
					target='_blank'
				>
					{element}
				</a>
			)
		}
		return element
	})
}

export { processText }
